import { render, staticRenderFns } from "./SpyderTikTokIcon.vue?vue&type=template&id=4405731c"
import script from "./SpyderTikTokIcon.vue?vue&type=script&lang=js"
export * from "./SpyderTikTokIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports